import { render, staticRenderFns } from "./BannerClassDetailView.vue?vue&type=template&id=ac28d632&scoped=true"
import script from "./BannerClassDetailView.vue?vue&type=script&lang=js"
export * from "./BannerClassDetailView.vue?vue&type=script&lang=js"
import style0 from "./BannerClassDetailView.vue?vue&type=style&index=0&id=ac28d632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac28d632",
  null
  
)

export default component.exports